var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPollsTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6652 3.9875C14.6652 5.40977 13.5094 6.56563 12.0871 6.56563H2.57812C1.15586 6.56563 0 5.40977 0 3.9875C0 2.56524 1.15586 1.40938 2.57812 1.40938H12.0871C13.5137 1.40938 14.6652 2.56094 14.6652 3.9875Z",
    fill: "#00528C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22 11C22 12.4223 20.8441 13.5781 19.4219 13.5781H2.57812C1.15586 13.5781 0 12.4223 0 11C0 9.57773 1.15586 8.42188 2.57812 8.42188H19.4219C20.8441 8.42188 22 9.57773 22 11Z",
    fill: "#41A5EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.33477 18.0125C7.33477 19.4348 6.17891 20.5906 4.75664 20.5906H2.57812C1.15586 20.5906 0 19.4348 0 18.0125C0 16.5902 1.15586 15.4344 2.57812 15.4344H4.75664C6.17891 15.4344 7.33477 16.5902 7.33477 18.0125Z",
    fill: "#0077CC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPollsTab);
export default __webpack_public_path__ + "static/media/pollsTab.ffb13603a5182f6f73d01643a661f5a7.svg";
export { ForwardRef as ReactComponent };